export enum ConsultationPlace {
    atConsult = 'In de praktijk',
    remotely = 'Op afstand (telefonisch of met videobellen)',
}
